import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mb-4 brg-input-section d-flex justify-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_SearchInput = _resolveComponent("SearchInput");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SearchInput, {
            ref: "searchInput",
            "default-value": _ctx.getterFilterOptionSearchWord,
            outlined: "",
            class: "search-text-field",
            placeholder: "라이더명 입력",
            "on-search": _ctx.handleSearch
        }, null, 8 /* PROPS */, ["default-value", "on-search"])
    ]));
}
